// import "styles/main.css";
// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// // Admin imports
// import RedcapDashboard from "pages/admin/RedcapDashboard";
// import AdminDashboard from "pages/admin/AdminDashboard";
// import AdminProfile from "pages/admin/AdminProfile";
// import UserManagement from "pages/admin/UserManagement";
// import UserProfile from "pages/admin/UserProfile";
// import ReasonForEdit from "pages/admin/ReasonForEdit";
// import EditUserAccount from "pages/admin/EditUserAccount";
// import EditUserConfirmation from "pages/admin/EditUserConfirmation";
// import AddEditStudy from "pages/admin/AddEditStudy";
// import ProvidersManagement from "pages/admin/ProvidersManagement";
// import PatientData from "pages/admin/PatientData";
// import SampleData from "pages/admin/SampleData";
// import SampleProfile from "pages/admin/SampleProfile";
// import PatientProfile from "pages/admin/PatientProfile";
// import ConsentManagementDashboard from "pages/admin/ConsentManagementDashboard";
// import ReviewsApprovalsDashboard from "pages/admin/ReviewsApprovalsDashboard";
// import ConsentFormManagement from "pages/admin/ConsentFormManagement";

// // BioBank module imports
// import Dashboard from "pages/biobank/dashboard/Dashboard";
// import CollectionKit from "pages/biobank/collection-kits/CollectionKit";
// import CollectionKitNumber from "pages/biobank/collection-kits/KitNumber";
// import PatientSchedule from "pages/biobank/participant-scheduling/PatientSchedule";
// import AddPatientForm from "pages/biobank/participant-scheduling/AddPatientForm";
// import VerifyPatientAccount from "pages/biobank/participant-scheduling/VerifyPatientAccount";
// import ConfirmPatientInfo from "pages/biobank/participant-scheduling/ConfirmPatientInfo";
// import AddAppointmentDetails from "pages/biobank/participant-scheduling/AddAppointmentDetails";
// import SampleCollection from "pages/biobank/sample-collection/SampleCollection";
// import AliquotProcessing from "pages/biobank/sample-processing/AliquotProcessing";
// import AliquotVerify from "pages/biobank/sample-processing/AliquotVerify";
// import AliquotDetails from "pages/biobank/sample-processing/AliquotDetails";
// import AliquotBarcodeAssignment from "pages/biobank/sample-processing/AliquotBarcodeAssignment";
// import AliquotStorageAssignment from "pages/biobank/sample-processing/AliquotStorageAssignment";
// import FollowUpDashboard from "pages/biobank/followup-management/FollowUpDashboard";
// import ProjectManagement from "pages/biobank/project-management/ProjectManagement";
// import AddProjectForm from "pages/biobank/project-management/AddProjectForm";
// import ProjectDetails from "pages/biobank/project-management/ProjectDetails";
// import EmailCenter from "pages/biobank/email-center/EmailCenter";
// import EmailTemplateProfile from "pages/biobank/email-center/EmailTemplateProfile";

// // BioBank legacy pages (not in navigation)
// import Table1 from "pages/biobank/legacy/BioBankProject";
// import Table2 from "pages/biobank/legacy/BioBankProjectSpecimen";
// import Table3 from "pages/biobank/legacy/BioBankChain";
// import Table4 from "pages/biobank/legacy/BioBankDonorChain";
// import Table5 from "pages/biobank/legacy/BioBankBioSpecimenChain";
// import Table6 from "pages/biobank/legacy/BioBankUsageChain";
// import BioBankUsageDetails from "pages/biobank/legacy/BioBankUsageDetails";
// import Table7 from "pages/biobank/legacy/BioBankMicroSampleChain";

// // Layout and common components
// import MainLayout from "components/MainLayout";

// // Onboarding imports
// import OnboardingTutorial from "./pages/onboarding/OnboardingTutorial";
// import BasicInformation from "./pages/onboarding/BasicInformation";
// import SuccessScreen from "./pages/onboarding/SuccessScreen";

// // Sample Collection Phase 4 imports
// import EncounterPlan from "pages/biobank/sample-collection/EncounterPlan";
// import FollowUpCollection from "pages/biobank/sample-collection/FollowUpCollection";
// import ReviewCollectionDetails from "pages/biobank/sample-collection/ReviewCollectionDetails";
// import CollectionDetailsAndAuthorization from "pages/biobank/sample-collection/CollectionDetailsAndAuthorization";
// import CommentsAndSubmit from "pages/biobank/sample-collection/CommentsAndSubmit";
// import { WizardProvider } from "pages/biobank/sample-collection/WizardContext";

// // Participant Check-in imports
// import PatientCheckIn from "pages/biobank/participant-checkin/PatientCheckIn";
// import ConfirmPatientCheckInInfo from "pages/biobank/participant-checkin/ConfirmPatientInfo";
// import EditPatientInfo from "pages/biobank/participant-checkin/EditPaitentInfo";
// import ReviewPatientInfo from "pages/biobank/participant-checkin/ReviewPatientInfo";
// import GettingStarted from "pages/biobank/participant-checkin/GettingStarted";
// import GeneralInfo from "pages/biobank/participant-checkin/GeneralInfo";
// import FamilyInfo from "pages/biobank/participant-checkin/FamilyInfo";
// import ConsentCheck from "pages/biobank/participant-checkin/ConsentCheck";
// import StudySelection from "pages/biobank/participant-checkin/StudySelection";
// import PatientCheckInLayout from "pages/biobank/participant-checkin/PatientProvider";

// // Aliquot Management imports
// import AliquotManagement from "pages/biobank/aliquot-management/AliquotManagement";
// import CheckInAliquots from "pages/biobank/aliquot-management/CheckInAliquots";
// import AssignAliquotStorage from "pages/biobank/aliquot-management/AssignAliquotStorage";
// import AliquotStorageLocationDetails from "pages/biobank/aliquot-management/AliquotStorageLocationDetails";
// import AssignAliquotQuantities from "pages/biobank/aliquot-management/AssignAliquotQuantities";

// // Profile imports
// import Profile from "./pages/profile/Profile";
// import EditAdvisor from "./pages/profile/EditAdvisor";
// import EditDepartment from "./pages/profile/EditDepartment";
// import EditJobRole from "./pages/profile/EditJobRole";
// import EditPurpose from "./pages/profile/EditPurpose";
// import EditWorkPhone from "./pages/profile/EditWorkPhone";

// // Auth imports
// import TermsAndConditions from "./pages/auth/TermsAndConditions";
// import AdobeSignCallback from "./pages/auth/AdobeSignCallback";

// // Researcher imports
// import ResearcherDashboard from "./pages/researcher/Dashboard";
// import Reports from "./pages/researcher/Reports";
// import Projects from "./pages/researcher/ResearchProjects";
// import DataAnalysis from "./pages/researcher/DataAnalysis";

// // Utils and providers
// import { getuserId, login, getToken } from "./utils/auth";
// import { fetchUserData } from "./utils/api";
// import { ThemeProvider } from "@mui/material/styles";
// import theme from "./theme";
// import ScrollToTop from "components/ScrollToTop";
// import GenericFormContextLayout from "components/GenericFormContextLayout";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import weekOfYear from "dayjs/plugin/weekOfYear";
// import { SnackbarProvider } from "components/snackbar/SnackbarProvider";
// import { BIOBANK_ROUTES, BIOBANK_SUB_ROUTES, ADMIN_ROUTES } from "./constants/routes";

// dayjs.extend(weekOfYear);

// function App() {
//   const [showBasicInfo, setShowBasicInfo] = useState(false);
//   const [registrationComplete, setRegistrationComplete] = useState(false);
//   const [termsAccepted, setTermsAccepted] = useState(false);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [userExists, setUserExists] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const checkAuthAndUserStatus = async () => {
//       setIsLoading(true);
//       let retryCount = 0;
//       const MAX_RETRIES = 3;

//       try {
//         const token = await getToken();
//         const userId = getuserId();

//         if (!token || !userId) {
//           setIsAuthenticated(false);
//           setUserExists(false);
//           return;
//         }

//         // Console log user roles from token in App.js
//         try {
//           const { jwtDecode } = await import("jwt-decode");
//           const tokenData = jwtDecode(token);
//           console.log("App.js - User Token Data:", tokenData);
//           console.log(
//             "App.js - User Roles:",
//             tokenData.realm_access?.roles || [],
//           );
//           console.log("App.js - User Groups:", tokenData.groups || []);
//           console.log(
//             "App.js - User Permissions:",
//             tokenData.permissions || [],
//           );
//         } catch (error) {
//           console.error("Error decoding token in App.js:", error);
//         }

//         setIsAuthenticated(true);

//         while (retryCount < MAX_RETRIES) {
//           try {
//             const userData = await fetchUserData();

//             // If we get a 404, it means user truly doesn't exist
//             if (userData === null) {
//               console.log("User needs onboarding");
//               setUserExists(false);
//               setTermsAccepted(false);
//               setShowBasicInfo(false);
//               break;
//             }

//             // User exists and we have their data
//             if (userData) {
//               setUserExists(true);
//               setRegistrationComplete(true);
//               setTermsAccepted(userData.acceptedTermsAndConditions === true);
//               setShowBasicInfo(true);
//               break;
//             }
//           } catch (error) {
//             retryCount++;

//             // If it's a 404 or 500, user needs to be created
//             if (
//               error.response &&
//               (error.response.status === 404 || error.response.status === 500)
//             ) {
//               setUserExists(false);
//               setTermsAccepted(false);
//               setShowBasicInfo(false);
//               break;
//             }

//             // For other errors, retry if we haven't hit max retries
//             if (retryCount < MAX_RETRIES) {
//               console.warn(
//                 `Failed to fetch user data, attempt ${retryCount} of ${MAX_RETRIES}`,
//               );
//               const delay = 1000 * retryCount;
//               await new Promise((resolve) => setTimeout(resolve, delay));
//               continue;
//             }

//             // If we've exhausted retries, throw the error
//             throw error;
//           }
//         }
//       } catch (error) {
//         console.error("Error checking user status:", error);
//         // On critical errors, we should probably redirect to an error page
//         // rather than assuming user doesn't exist
//         setIsAuthenticated(false);
//         setUserExists(false);
//         setTermsAccepted(false);
//         setShowBasicInfo(false);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     checkAuthAndUserStatus();
//   }, []);

//   const handleNextClick = () => {
//     setShowBasicInfo(true);
//   };

//   const handleSuccess = () => {
//     setRegistrationComplete(true);
//     setUserExists(true);
//     setTermsAccepted(true); // Set terms as accepted after registration
//   };

//   const handleTermsAccept = () => {
//     setTermsAccepted(true);
//   };

//   // Handle login redirect
//   const handleLoginRedirect = () => {
//     login(); // This will redirect to Keycloak login
//     return null;
//   };

//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         Loading...
//       </div>
//     );
//   }

//   return (
//     <ThemeProvider theme={theme}>
//       <LocalizationProvider dateAdapter={AdapterDayjs}>
//         <SnackbarProvider>
//           <Router>
//             <ScrollToTop>
//               <div className="App">
//                 <Routes>
//                   <Route
//                     path="/"
//                     element={
//                       !isAuthenticated ? (
//                         handleLoginRedirect()
//                       ) : userExists ? (
//                         <Navigate to={BIOBANK_ROUTES.DASHBOARD} replace />
//                       ) : !termsAccepted ? (
//                         <TermsAndConditions onAccept={handleTermsAccept} />
//                       ) : !showBasicInfo ? (
//                         <OnboardingTutorial onNextClick={handleNextClick} />
//                       ) : (
//                         <BasicInformation onSuccess={handleSuccess} />
//                       )
//                     }
//                   />
//                   <Route
//                     path="/success"
//                     element={
//                       !isAuthenticated ? (
//                         handleLoginRedirect()
//                       ) : registrationComplete ? (
//                         <SuccessScreen />
//                       ) : (
//                         <Navigate to="/" replace />
//                       )
//                     }
//                   />
//                   {/* BioBank Module - Main Routes */}
//                   <Route
//                     path="/biobank"
//                     element={
//                       !isAuthenticated ? (
//                         handleLoginRedirect()
//                       ) : !userExists ? (
//                         <Navigate to="/" replace />
//                       ) : (
//                         <MainLayout />
//                       )
//                     }
//                   >
//                     <Route index element={<Dashboard />} />

//                     {/* Legacy BioBank pages (not in navigation) */}
//                     <Route
//                       path="legacy/biobank-project"
//                       element={<Table1 />}
//                     />
//                     <Route
//                       path="legacy/biobank-project-specimen"
//                       element={<Table2 />}
//                     />
//                     <Route path="legacy/biobank-chain" element={<Table3 />} />
//                     <Route
//                       path="legacy/biobank-donor-chain"
//                       element={<Table4 />}
//                     />
//                     <Route
//                       path="legacy/biobank-biospecimen-chain"
//                       element={<Table5 />}
//                     />
//                     <Route
//                       path="legacy/biobank-usage-chain"
//                       element={<Table6 />}
//                     />
//                     <Route
//                       path="legacy/biobank-usage-chain/details/:usageId"
//                       element={<BioBankUsageDetails />}
//                     />
//                     <Route
//                       path="legacy/biobank-microsample-chain"
//                       element={<Table7 />}
//                     />

//                     {/* Collection Kits */}
//                     <Route path="collection-kits" element={<CollectionKit />} />
//                     <Route path="collection-kits/new" element={<CollectionKitNumber />} />

//                     {/* Participant Scheduling */}
//                     <Route
//                       path="participant-scheduling"
//                       element={<PatientSchedule />}
//                     />
//                     <Route path="participant-scheduling/verify" element={<VerifyPatientAccount />} />
//                     <Route path="participant-scheduling/add" element={<AddPatientForm />} />
//                     <Route path="participant-scheduling/confirm" element={<ConfirmPatientInfo />} />
//                     <Route path="participant-scheduling/add-appointment" element={<AddAppointmentDetails />} />

//                     {/* Participant Check-in Entry */}
//                     <Route
//                       path="participant-checkin"
//                       element={<PatientCheckIn />}
//                     />

//                     {/* Sample Collection */}
//                     <Route
//                       path="sample-collection"
//                       element={<SampleCollection />}
//                     />

//                     {/* Sample Processing (Aliquot) */}
//                     <Route
//                       path="sample-processing"
//                       element={<AliquotProcessing />}
//                     />
//                     <Route path="sample-processing/verify/:barcode" element={<AliquotVerify />} />
//                     <Route path="sample-processing/process/:barcode" element={<AliquotDetails />} />
//                     <Route path="sample-processing/barcode-assignment/:sampleId?/:aliquotCount?" element={<AliquotBarcodeAssignment />} />
//                     <Route path="sample-processing/storage-assignment/:sampleId?" element={<AliquotStorageAssignment />} />

//                     {/* Aliquot Management */}
//                     <Route
//                       path="aliquot-management"
//                       element={<AliquotManagement />}
//                     />

//                     {/* Follow-up Management */}
//                     <Route
//                       path="followup-management"
//                       element={<FollowUpDashboard />}
//                     />

//                     {/* Project Management */}
//                     <Route
//                       path="project-management"
//                       element={<ProjectManagement />}
//                     />
//                     <Route
//                       path="project-management/:projectId"
//                       element={<ProjectDetails />}
//                     />
//                     <Route path="project-management/add" element={<AddProjectForm />} />

//                     {/* Email Center */}
//                     <Route path="email-center" element={<EmailCenter />} />
//                     <Route
//                       path="email-center/templates/:specCode/:language"
//                       element={<EmailTemplateProfile />}
//                     />

//                     {/* Profile (shared across modules) */}
//                     <Route path="profile" element={<Profile />} />
//                     <Route path="profile/edit-department" element={<EditDepartment />} />
//                     <Route path="profile/edit-work-phone" element={<EditWorkPhone />} />
//                     <Route path="profile/edit-job-role" element={<EditJobRole />} />
//                     <Route path="profile/edit-advisor" element={<EditAdvisor />} />
//                     <Route path="profile/edit-purpose" element={<EditPurpose />} />
//                   </Route>

//                   {/* Legacy /dashboard route - redirect to /biobank */}
//                   <Route
//                     path="/dashboard"
//                     element={<Navigate to={BIOBANK_ROUTES.DASHBOARD} replace />}
//                   />
//                   <Route
//                     path="/dashboard/*"
//                     element={<Navigate to={BIOBANK_ROUTES.DASHBOARD} replace />}
//                   />

//                   {/* BioBank - Aliquot Management Check-in Flow */}
//                   <Route
//                     path="/biobank/aliquot-management/check-in-out"
//                     element={
//                       <GenericFormContextLayout
//                         value={{
//                           formDataName: "checkInAliquotData",
//                           emptyFormData: {
//                             box: "",
//                             barcode: "",
//                             freezer: "",
//                             rack: "",
//                             aliquots: [],
//                           },
//                         }}
//                       />
//                     }
//                   >
//                     <Route
//                       path="check-in-aliquots"
//                       element={<CheckInAliquots />}
//                     />
//                     <Route
//                       path="aliquot-storage-location-details"
//                       element={<AliquotStorageLocationDetails />}
//                     />
//                     <Route
//                       path="assign-aliquot-storage"
//                       element={<AssignAliquotStorage />}
//                     />
//                     <Route
//                       path="assign-aliquot-quantities"
//                       element={<AssignAliquotQuantities />}
//                     />
//                   </Route>

//                   {/* BioBank - Sample Collection Phase 4 */}
//                   <Route path="/biobank/sample-collection">
//                     <Route
//                       path="plan/:encounterId"
//                       element={<EncounterPlan />}
//                     />
//                     <Route
//                       path="followup/:encounterId"
//                       element={<FollowUpCollection />}
//                     />
//                   </Route>

//                   {/* BioBank - Sample Collection Wizard (with WizardProvider) */}
//                   <Route
//                     path="/biobank/sample-collection/encounters/:encounterId/batches/:batchId/*"
//                     element={
//                       <WizardProvider>
//                         <Routes>
//                           <Route
//                             path="review"
//                             element={<ReviewCollectionDetails />}
//                           />
//                           <Route
//                             path="authorization"
//                             element={<CollectionDetailsAndAuthorization />}
//                           />
//                           <Route
//                             path="submit"
//                             element={<CommentsAndSubmit />}
//                           />
//                         </Routes>
//                       </WizardProvider>
//                     }
//                   />

//                   {/* BioBank - Participant Check-in Wizard */}
//                   <Route
//                     path="/biobank/participant-checkin/wizard/*"
//                     element={
//                       <PatientCheckInLayout>
//                         <Routes>
//                           <Route
//                             path="getting-started"
//                             element={<GettingStarted />}
//                           />
//                           <Route
//                             path="confirm-patient-info"
//                             element={<ConfirmPatientCheckInInfo />}
//                           />
//                           <Route
//                             path="edit-patient-info"
//                             element={<EditPatientInfo />}
//                           />
//                           <Route
//                             path="general-info"
//                             element={<GeneralInfo />}
//                           />
//                           <Route path="family-info" element={<FamilyInfo />} />
//                           <Route
//                             path="study-selection"
//                             element={<StudySelection />}
//                           />
//                           <Route
//                             path="consent-check"
//                             element={<ConsentCheck />}
//                           />
//                           {/* Deprecated drop-in routes removed */}
//                         </Routes>
//                       </PatientCheckInLayout>
//                     }
//                   />

//                   {/* Legacy profile routes - redirect to new paths */}
//                   <Route path="/edit-department" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_DEPARTMENT} replace />} />
//                   <Route path="/edit-work-phone" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_WORK_PHONE} replace />} />
//                   <Route path="/edit-job-role" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_JOB_ROLE} replace />} />
//                   <Route path="/edit-advisor" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_ADVISOR} replace />} />
//                   <Route path="/edit-purpose" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_PURPOSE} replace />} />
//                   <Route
//                     path="/admin/*"
//                     element={
//                       !isAuthenticated ? (
//                         handleLoginRedirect()
//                       ) : !userExists ? (
//                         <Navigate to="/" replace />
//                       ) : (
//                         <MainLayout />
//                       )
//                     }
//                   >
//                     <Route index element={<AdminDashboard />} />
//                     <Route path="redcap" element={<RedcapDashboard />} />
//                     <Route path="profile" element={<AdminProfile />} />
//                     <Route path="users" element={<UserManagement />} />
//                     <Route
//                       path="users/profile/:userId"
//                       element={<UserProfile />}
//                     />
//                     <Route path="users/reason" element={<ReasonForEdit />} />
//                     <Route path="users/edit" element={<EditUserAccount />} />
//                     <Route
//                       path="users/confirm"
//                       element={<EditUserConfirmation />}
//                     />
//                     <Route
//                       path="consent-management"
//                       element={<ConsentManagementDashboard />}
//                     />
//                     <Route
//                       path="reviews-approvals"
//                       element={<ReviewsApprovalsDashboard />}
//                     />
//                     <Route path="add-edit-study" element={<AddEditStudy />} />
//                     <Route path="patient-data" element={<PatientData />} />
//                     <Route
//                       path="patient-profile"
//                       element={<PatientProfile />}
//                     />
//                     <Route path="samples" element={<SampleData />} />
//                     <Route
//                       path="samples/:sampleId"
//                       element={<SampleProfile />}
//                     />
//                     <Route
//                       path="consent/forms-management"
//                       element={<ConsentFormManagement />}
//                     />
//                     <Route path="programs" element={<ProvidersManagement />} />
//                     <Route
//                       path="*"
//                       element={<Navigate to={ADMIN_ROUTES.DASHBOARD} replace />}
//                     />
//                   </Route>

//                   {/* Adobe Sign OAuth Callback */}
//                   <Route
//                     path="/adobe-sign-callback"
//                     element={<AdobeSignCallback />}
//                   />
//                   {/* <Route path="/researcher" element={<Researcher />} /> */}
//                   {/* <Route path="/researcher/reports" element={<Reports />} /> */}

//                   <Route path="/researcher/*" element={<MainLayout />}>
//                     <Route index element={<ResearcherDashboard />} />
//                     <Route path="projects" element={<Projects />} />
//                     <Route path="analysis" element={<DataAnalysis />} />
//                     <Route path="reports" element={<Reports />} />
//                   </Route>
//                 </Routes>
//               </div>
//             </ScrollToTop>
//           </Router>
//         </SnackbarProvider>
//       </LocalizationProvider>
//     </ThemeProvider>
//   );
// }

// export default App;
import "styles/main.css";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// Admin imports
import RedcapDashboard from "pages/admin/RedcapDashboard";
import AdminDashboard from "pages/admin/AdminDashboard";
import AdminProfile from "pages/admin/AdminProfile";
import UserManagement from "pages/admin/UserManagement";
import UserProfile from "pages/admin/UserProfile";
import ReasonForEdit from "pages/admin/ReasonForEdit";
import EditUserAccount from "pages/admin/EditUserAccount";
import EditUserConfirmation from "pages/admin/EditUserConfirmation";
import AddEditStudy from "pages/admin/AddEditStudy";
import ProvidersManagement from "pages/admin/ProvidersManagement";
import PatientData from "pages/admin/PatientData";
import SampleData from "pages/admin/SampleData";
import SampleProfile from "pages/admin/SampleProfile";
import PatientProfile from "pages/admin/PatientProfile";
import ConsentManagementDashboard from "pages/admin/ConsentManagementDashboard";
import ReviewsApprovalsDashboard from "pages/admin/ReviewsApprovalsDashboard";
import ConsentFormManagement from "pages/admin/ConsentFormManagement";

// BioBank module imports
import Dashboard from "pages/biobank/dashboard/Dashboard";
import CollectionKit from "pages/biobank/collection-kits/CollectionKit";
import CollectionKitNumber from "pages/biobank/collection-kits/KitNumber";
import PatientSchedule from "pages/biobank/participant-scheduling/PatientSchedule";
import AddPatientForm from "pages/biobank/participant-scheduling/AddPatientForm";
import VerifyPatientAccount from "pages/biobank/participant-scheduling/VerifyPatientAccount";
import ConfirmPatientInfo from "pages/biobank/participant-scheduling/ConfirmPatientInfo";
import AddAppointmentDetails from "pages/biobank/participant-scheduling/AddAppointmentDetails";
import SampleCollection from "pages/biobank/sample-collection/SampleCollection";
import AliquotProcessing from "pages/biobank/sample-processing/AliquotProcessing";
import AliquotVerify from "pages/biobank/sample-processing/AliquotVerify";
import AliquotDetails from "pages/biobank/sample-processing/AliquotDetails";
import AliquotBarcodeAssignment from "pages/biobank/sample-processing/AliquotBarcodeAssignment";
import AliquotStorageAssignment from "pages/biobank/sample-processing/AliquotStorageAssignment";
import FollowUpDashboard from "pages/biobank/followup-management/FollowUpDashboard";
import ProjectManagement from "pages/biobank/project-management/ProjectManagement";
import AddProjectForm from "pages/biobank/project-management/AddProjectForm";
import ProjectDetails from "pages/biobank/project-management/ProjectDetails";
import EmailCenter from "pages/biobank/email-center/EmailCenter";
import EmailTemplateProfile from "pages/biobank/email-center/EmailTemplateProfile";

// BioBank legacy pages (not in navigation)
import Table1 from "pages/biobank/legacy/BioBankProject";
import Table2 from "pages/biobank/legacy/BioBankProjectSpecimen";
import Table3 from "pages/biobank/legacy/BioBankChain";
import Table4 from "pages/biobank/legacy/BioBankDonorChain";
import Table5 from "pages/biobank/legacy/BioBankBioSpecimenChain";
import Table7 from "pages/biobank/legacy/BioBankMicroSampleChain";

// Layout and common components
import MainLayout from "components/MainLayout";

// Onboarding imports
import OnboardingTutorial from "./pages/onboarding/OnboardingTutorial";
import BasicInformation from "./pages/onboarding/BasicInformation";
import SuccessScreen from "./pages/onboarding/SuccessScreen";

// Sample Collection Phase 4 imports
import EncounterPlan from "pages/biobank/sample-collection/EncounterPlan";
import FollowUpCollection from "pages/biobank/sample-collection/FollowUpCollection";
import ReviewCollectionDetails from "pages/biobank/sample-collection/ReviewCollectionDetails";
import CollectionDetailsAndAuthorization from "pages/biobank/sample-collection/CollectionDetailsAndAuthorization";
import CommentsAndSubmit from "pages/biobank/sample-collection/CommentsAndSubmit";
import { WizardProvider } from "pages/biobank/sample-collection/WizardContext";

// Participant Check-in imports
import PatientCheckIn from "pages/biobank/participant-checkin/PatientCheckIn";
import ConfirmPatientCheckInInfo from "pages/biobank/participant-checkin/ConfirmPatientInfo";
import GettingStarted from "pages/biobank/participant-checkin/GettingStarted";
import GeneralInfo from "pages/biobank/participant-checkin/GeneralInfo";
import FamilyInfo from "pages/biobank/participant-checkin/FamilyInfo";
import ConsentCheck from "pages/biobank/participant-checkin/ConsentCheck";
import PatientCheckInLayout from "pages/biobank/participant-checkin/PatientProvider";

// Aliquot Management imports
import AliquotManagement from "pages/biobank/aliquot-management/AliquotManagement";
import CheckInAliquots from "pages/biobank/aliquot-management/CheckInAliquots";
import AliquotStorageLocationDetails from "pages/biobank/aliquot-management/AliquotStorageLocationDetails";

// Profile imports
import Profile from "./pages/profile/Profile";
import EditAdvisor from "./pages/profile/EditAdvisor";
import EditDepartment from "./pages/profile/EditDepartment";
import EditJobRole from "./pages/profile/EditJobRole";
import EditPurpose from "./pages/profile/EditPurpose";
import EditWorkPhone from "./pages/profile/EditWorkPhone";

// Auth imports
import TermsAndConditions from "./pages/auth/TermsAndConditions";
import AdobeSignCallback from "./pages/auth/AdobeSignCallback";

// Researcher imports
import ResearcherDashboard from "./pages/researcher/Dashboard";
import Reports from "./pages/researcher/Reports";
import Projects from "./pages/researcher/ResearchProjects";
import DataAnalysis from "./pages/researcher/DataAnalysis";
import ResearcherBiobankDashboard from "./pages/researcher/BiobankDashboard";
import WearableDeviceDashboard from "./pages/researcher/WearableDeviceDashboard";

// Utils and providers
import { getuserId, login, getToken } from "./utils/auth";
import { fetchUserData } from "./utils/api";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import ScrollToTop from "components/ScrollToTop";
import GenericFormContextLayout from "components/GenericFormContextLayout";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { SnackbarProvider } from "components/snackbar/SnackbarProvider";
import { TourProvider } from "tour/TourProvider";
import { BIOBANK_ROUTES, BIOBANK_SUB_ROUTES, ADMIN_ROUTES } from "./constants/routes";

dayjs.extend(weekOfYear);

function App() {
  const [showBasicInfo, setShowBasicInfo] = useState(false);
  const [registrationComplete, setRegistrationComplete] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userExists, setUserExists] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthAndUserStatus = async () => {
      setIsLoading(true);
      let retryCount = 0;
      const MAX_RETRIES = 3;

      try {
        const token = await getToken();
        const userId = getuserId();

        if (!token || !userId) {
          setIsAuthenticated(false);
          setUserExists(false);
          return;
        }

        try {
          const { jwtDecode } = await import("jwt-decode");
          jwtDecode(token);
        } catch (error) {
          console.error("Error decoding token in App.js:", error);
        }

        setIsAuthenticated(true);

        while (retryCount < MAX_RETRIES) {
          try {
            const userData = await fetchUserData();

            // If we get a 404, it means user truly doesn't exist
            if (userData === null) {
              setUserExists(false);
              setTermsAccepted(false);
              setShowBasicInfo(false);
              break;
            }

            // User exists and we have their data
            if (userData) {
              setUserExists(true);
              setRegistrationComplete(true);
              setTermsAccepted(userData.acceptedTermsAndConditions === true);
              setShowBasicInfo(true);
              break;
            }
          } catch (error) {
            retryCount++;

            // If it's a 404 or 500, user needs to be created
            if (
              error.response &&
              (error.response.status === 404 || error.response.status === 500)
            ) {
              setUserExists(false);
              setTermsAccepted(false);
              setShowBasicInfo(false);
              break;
            }

            // For other errors, retry if we haven't hit max retries
            if (retryCount < MAX_RETRIES) {
              console.warn(
                `Failed to fetch user data, attempt ${retryCount} of ${MAX_RETRIES}`,
              );
              const delay = 1000 * retryCount;
              await new Promise((resolve) => setTimeout(resolve, delay));
              continue;
            }

            // If we've exhausted retries, throw the error
            throw error;
          }
        }
      } catch (error) {
        console.error("Error checking user status:", error);
        // On critical errors, we should probably redirect to an error page
        // rather than assuming user doesn't exist
        setIsAuthenticated(false);
        setUserExists(false);
        setTermsAccepted(false);
        setShowBasicInfo(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthAndUserStatus();
  }, []);

  const handleNextClick = () => {
    setShowBasicInfo(true);
  };

  const handleSuccess = () => {
    setRegistrationComplete(true);
    setUserExists(true);
    setTermsAccepted(true); // Set terms as accepted after registration
  };

  const handleTermsAccept = () => {
    setTermsAccepted(true);
  };

  // Handle login redirect
  const handleLoginRedirect = () => {
    login(); // This will redirect to Keycloak login
    return null;
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <SnackbarProvider>
          <Router>
            <ScrollToTop>
              <div className="App">
                <TourProvider>
                <Routes>
                  <Route
                    path="/"
                    element={
                      !isAuthenticated ? (
                        handleLoginRedirect()
                      ) : userExists ? (
                        <Navigate to={BIOBANK_ROUTES.DASHBOARD} replace />
                      ) : !termsAccepted ? (
                        <TermsAndConditions onAccept={handleTermsAccept} />
                      ) : !showBasicInfo ? (
                        <OnboardingTutorial onNextClick={handleNextClick} />
                      ) : (
                        <BasicInformation onSuccess={handleSuccess} />
                      )
                    }
                  />
                  <Route
                    path="/success"
                    element={
                      !isAuthenticated ? (
                        handleLoginRedirect()
                      ) : registrationComplete ? (
                        <SuccessScreen />
                      ) : (
                        <Navigate to="/" replace />
                      )
                    }
                  />
                  {/* BioBank Module - Main Routes */}
                  <Route
                    path="/biobank"
                    element={
                      !isAuthenticated ? (
                        handleLoginRedirect()
                      ) : !userExists ? (
                        <Navigate to="/" replace />
                      ) : (
                        <MainLayout />
                      )
                    }
                  >
                    <Route index element={<Dashboard />} />

                    {/* Legacy BioBank pages (not in navigation) */}
                    <Route
                      path="legacy/biobank-project"
                      element={<Table1 />}
                    />
                    <Route
                      path="legacy/biobank-project-specimen"
                      element={<Table2 />}
                    />
                    <Route path="legacy/biobank-chain" element={<Table3 />} />
                    <Route
                      path="legacy/biobank-donor-chain"
                      element={<Table4 />}
                    />
                    <Route
                      path="legacy/biobank-biospecimen-chain"
                      element={<Table5 />}
                    />
                    <Route
                      path="legacy/biobank-usage-chain"
                      element={<Navigate to={BIOBANK_SUB_ROUTES.ALIQUOT_MANAGEMENT_USAGE_HISTORY} replace />}
                    />
                    <Route
                      path="legacy/biobank-usage-chain/details/:usageId"
                      element={<Navigate to={BIOBANK_SUB_ROUTES.ALIQUOT_MANAGEMENT_USAGE_HISTORY} replace />}
                    />
                    <Route
                      path="legacy/biobank-microsample-chain"
                      element={<Table7 />}
                    />

                    {/* Collection Kits */}
                    <Route path="collection-kits" element={<CollectionKit />} />
                    <Route path="collection-kits/new" element={<CollectionKitNumber />} />

                    {/* Participant Scheduling */}
                    <Route
                      path="participant-scheduling"
                      element={<PatientSchedule />}
                    />
                    <Route path="participant-scheduling/verify" element={<VerifyPatientAccount />} />
                    <Route path="participant-scheduling/add" element={<AddPatientForm />} />
                    <Route path="participant-scheduling/confirm" element={<ConfirmPatientInfo />} />
                    <Route path="participant-scheduling/add-appointment" element={<AddAppointmentDetails />} />

                    {/* Participant Check-in Entry */}
                    <Route
                      path="participant-checkin"
                      element={<PatientCheckIn />}
                    />

                    {/* Sample Collection */}
                    <Route
                      path="sample-collection"
                      element={<SampleCollection />}
                    />

                    {/* Sample Processing (Aliquot) */}
                    <Route
                      path="sample-processing"
                      element={<AliquotProcessing />}
                    />
                    <Route path="sample-processing/verify/:barcode" element={<AliquotVerify />} />
                    <Route path="sample-processing/process/:barcode" element={<AliquotDetails />} />
                    <Route path="sample-processing/barcode-assignment/:sampleId?/:aliquotCount?" element={<AliquotBarcodeAssignment />} />
                    <Route path="sample-processing/storage-assignment/:sampleId?" element={<AliquotStorageAssignment />} />

                    {/* Aliquot Management */}
                    <Route
                      path="aliquot-management"
                      element={<AliquotManagement />}
                    />

                    {/* Follow-up Management */}
                    <Route
                      path="followup-management"
                      element={<FollowUpDashboard />}
                    />

                    {/* Project Management */}
                    <Route
                      path="project-management"
                      element={<ProjectManagement />}
                    />
                    <Route
                      path="project-management/:projectId"
                      element={<ProjectDetails />}
                    />
                    <Route path="project-management/add" element={<AddProjectForm />} />

                    {/* Email Center */}
                    <Route path="email-center" element={<EmailCenter />} />
                    <Route
                      path="email-center/templates/:specCode/:language"
                      element={<EmailTemplateProfile />}
                    />

                    {/* Profile (shared across modules) */}
                    <Route path="profile" element={<Profile />} />
                    <Route path="profile/edit-department" element={<EditDepartment />} />
                    <Route path="profile/edit-work-phone" element={<EditWorkPhone />} />
                    <Route path="profile/edit-job-role" element={<EditJobRole />} />
                    <Route path="profile/edit-advisor" element={<EditAdvisor />} />
                    <Route path="profile/edit-purpose" element={<EditPurpose />} />
                  </Route>

                  {/* Legacy /dashboard route - redirect to /biobank */}
                  <Route
                    path="/dashboard"
                    element={<Navigate to={BIOBANK_ROUTES.DASHBOARD} replace />}
                  />
                  <Route
                    path="/dashboard/*"
                    element={<Navigate to={BIOBANK_ROUTES.DASHBOARD} replace />}
                  />

                  {/* BioBank - Aliquot Management Check-in Flow */}
                  <Route
                    path="/biobank/aliquot-management/check-in-out"
                    element={
                      <GenericFormContextLayout
                        value={{
                          formDataName: "checkInAliquotData",
                          emptyFormData: {
                            box: "",
                            barcode: "",
                            freezer: "",
                            rack: "",
                            aliquots: [],
                          },
                        }}
                      />
                    }
                  >
                    <Route
                      path="check-in-aliquots"
                      element={<CheckInAliquots />}
                    />
                    <Route
                      path="aliquot-storage-location-details"
                      element={<AliquotStorageLocationDetails />}
                    />
                  </Route>

                  {/* BioBank - Sample Collection Phase 4 */}
                  <Route path="/biobank/sample-collection">
                    <Route
                      path="plan/:encounterId"
                      element={<EncounterPlan />}
                    />
                    <Route
                      path="followup/:encounterId"
                      element={<FollowUpCollection />}
                    />
                  </Route>

                  {/* BioBank - Sample Collection Wizard (with WizardProvider) */}
                  <Route
                    path="/biobank/sample-collection/encounters/:encounterId/batches/:batchId/*"
                    element={
                      <WizardProvider>
                        <Routes>
                          <Route
                            path="review"
                            element={<ReviewCollectionDetails />}
                          />
                          <Route
                            path="authorization"
                            element={<CollectionDetailsAndAuthorization />}
                          />
                          <Route
                            path="submit"
                            element={<CommentsAndSubmit />}
                          />
                        </Routes>
                      </WizardProvider>
                    }
                  />

                  {/* BioBank - Participant Check-in Wizard */}
                  <Route
                    path="/biobank/participant-checkin/wizard/*"
                    element={
                      <PatientCheckInLayout>
                        <Routes>
                          <Route
                            path="getting-started"
                            element={<GettingStarted />}
                          />
                          <Route
                            path="confirm-patient-info"
                            element={<ConfirmPatientCheckInInfo />}
                          />
                          {/* B3.5-W2 cleanup (2026-08-18): removed orphaned
                              "edit-patient-info" route (EditPaitentInfo.js) and the
                              unmounted ReviewPatientInfo.js import. Neither was
                              reachable from any navigate() call in the active
                              check-in wizard flow (FamilyInfo.js completes
                              check-in directly via checkInEncounterV2). See
                              graphchain-docs/active/standardize/decisions/b3.5_w2_field_removal_decisions.md */}
                          <Route
                            path="general-info"
                            element={<GeneralInfo />}
                          />
                          <Route path="family-info" element={<FamilyInfo />} />
                          <Route
                            path="consent-check"
                            element={<ConsentCheck />}
                          />
                          {/* Deprecated drop-in routes removed */}
                        </Routes>
                      </PatientCheckInLayout>
                    }
                  />

                  {/* Legacy profile routes - redirect to new paths */}
                  <Route path="/edit-department" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_DEPARTMENT} replace />} />
                  <Route path="/edit-work-phone" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_WORK_PHONE} replace />} />
                  <Route path="/edit-job-role" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_JOB_ROLE} replace />} />
                  <Route path="/edit-advisor" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_ADVISOR} replace />} />
                  <Route path="/edit-purpose" element={<Navigate to={BIOBANK_SUB_ROUTES.PROFILE_EDIT_PURPOSE} replace />} />
                  <Route
                    path="/admin/*"
                    element={
                      !isAuthenticated ? (
                        handleLoginRedirect()
                      ) : !userExists ? (
                        <Navigate to="/" replace />
                      ) : (
                        <MainLayout />
                      )
                    }
                  >
                    <Route index element={<AdminDashboard />} />
                    <Route path="redcap" element={<RedcapDashboard />} />
                    <Route path="profile" element={<AdminProfile />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route
                      path="users/profile/:userId"
                      element={<UserProfile />}
                    />
                    <Route path="users/reason" element={<ReasonForEdit />} />
                    <Route path="users/edit" element={<EditUserAccount />} />
                    <Route
                      path="users/confirm"
                      element={<EditUserConfirmation />}
                    />
                    <Route
                      path="consent-management"
                      element={<ConsentManagementDashboard />}
                    />
                    <Route
                      path="reviews-approvals"
                      element={<ReviewsApprovalsDashboard />}
                    />
                    <Route path="add-edit-study" element={<AddEditStudy />} />
                    <Route path="patient-data" element={<PatientData />} />
                    <Route
                      path="patient-profile"
                      element={<PatientProfile />}
                    />
                    <Route path="samples" element={<SampleData />} />
                    <Route
                      path="samples/:sampleId"
                      element={<SampleProfile />}
                    />
                    <Route
                      path="consent/forms-management"
                      element={<ConsentFormManagement />}
                    />
                    <Route path="programs" element={<ProvidersManagement />} />
                    <Route
                      path="*"
                      element={<Navigate to={ADMIN_ROUTES.DASHBOARD} replace />}
                    />
                  </Route>

                  {/* Adobe Sign OAuth Callback */}
                  <Route
                    path="/adobe-sign-callback"
                    element={<AdobeSignCallback />}
                  />
                  {/* <Route path="/researcher" element={<Researcher />} /> */}
                  {/* <Route path="/researcher/reports" element={<Reports />} /> */}

                  <Route path="/researcher/*" element={<MainLayout />}>
                    <Route index element={<ResearcherDashboard />} />
                    <Route path="projects" element={<Projects />} />
                    <Route path="analysis" element={<DataAnalysis />} />
                    <Route path="reports" element={<Reports />} />
                    <Route
                      path="biobank-dashboard"
                      element={<ResearcherBiobankDashboard />}
                    />
                    <Route
                      path="wearable-dashboard"
                      element={<WearableDeviceDashboard />}
                    />
                  </Route>
                </Routes>
                </TourProvider>
              </div>
            </ScrollToTop>
          </Router>
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
